import React, { useEffect, useMemo, useState } from 'react'
import { Wrapper, AvatarProfile, Btn } from '../_components'
import Table from '../_components/Table'
import Axios from 'axios'
import { useDispatch, useSelector } from 'react-redux'
import { getRegisteredFarmers } from '../_slices/AppSlice'
import { capitalize } from '../_utils'

const NameField = record => {
    let Name = record.value?.split(" ")

    return (
        <div className="flex flex-col items-start justify-center">
            <AvatarProfile bold label={`${capitalize( Name[ 0 ] )} ${capitalize( Name[ 1 ] )}`}/>
        </div>
    )
}

const ActionField = record => {
    const deActivate = async ( id ) => {
        try {
            const response = await Axios.post( `https://mis.nec.go.ug/api/auth/fiefoc_deactivate`, {
                id,
                flag: "deactivate"
            } ) 
            if( response.data ) {
               return window.location.reload()
            }
        } catch (error) {
            
        }
    } 
    const activate = async ( id ) => {
        try {
            const response = await Axios.post( `https://mis.nec.go.ug/api/auth/fiefoc_deactivate`, {
                id,
                flag: "activate"
            } ) 
            if( response.data ) {
               return window.location.reload()
            }
        } catch (error) {
            
        }
    } 

    const navigateTo = async ( id, tag ) => {
        await localStorage.setItem( "farmerId", id )
        await localStorage.setItem( "tag", tag )

        if( tag === "view" ) {
            await localStorage.setItem( "name", "register_farmer" )
            return window.location.reload()
        }
        
        if( tag === "edit" ) {
            await localStorage.setItem( "name", "register_farmer" )
            return window.location.reload()
        }
        
        if ( tag === "deactivate" ) {
            alert( "Do you want to deactivate the Farmer?" )
            await deActivate( id )
        }

        if ( tag === "activate" ) {
            alert( "Do you want to re-activate this Farmer?" )
            await activate( id )
        }
    }

    return (
        <div className="flex items-center">
            <Btn handlePress={() => navigateTo( record.value, "view")} label="View" color={`#8A3FFC`} />
            <Btn handlePress={() => navigateTo( record.value, "edit")} label="Edit" color={`#3F84FC`} />
            <Btn handlePress={() => navigateTo( record.value, ( record?.row.original.status === "1" ? "deactivate" : "activate" ) )} label={`${record?.row.original.status === "1" ? "Deactivate" : "Re-Activate" }`} color={`${ record?.row.original.status === "1" ? "#FC413F": "purple"}`} />
        </div>
    )
}

export default function Registered() {
    const dispatch = useDispatch()
    const state = useSelector( state => {
        return {
            farmers: state.application.farmers
        }
    } )
    const farmerColumns = useMemo(
    () => [
        {
            Header: "#",
            accessor: "fNo",
            sortable: false
        },
        {
            Header: "Name",
            accessor: "name",
            sortable: false,
            filterable: false,
            Cell: NameField
        },
        {
            Header: "Registration No.",
            accessor: "registration_no"
        },
        {
            Header: "Block ID",
            accessor: "block"
        },
        {
            Header: "FFSG No.",
            accessor: "ffs_code"
        },
        {
            Header: "Date Registered",
            accessor: "date"
        },
        {
            Header: "Actions",
            accessor: "id",
            Cell: ActionField
        },
        ]
    )

    const [ loading, setLoading ] = useState( true )
    useEffect( () => {
        if( loading ) {
            dispatch( getRegisteredFarmers() )
            setLoading( false )
        }
    },[ loading ])
    
    return (
    <Wrapper>
     <div className="flex flex-col border border-gray-200 relative">
        <h2 className="text-lg px-2 font-bold">
            {`Registered Farmers`}
        </h2>
        <div className="flex items-center justify-center absolute top-0 right-0">
            <Btn handlePress={ async () => {
                await localStorage.removeItem( "tag" )
                await localStorage.setItem( "name", "register_farmer" )
                return window.location.reload()
            } } label="Register New Farmer" color={`#1DAB47`} />
        </div>
        {loading ? (
            <div className="flex items-center justify-center">
                <span className="text-center text-base">
                    {`Loading Farmers in ${localStorage.getItem( "scheme")} Scheme...`}
                </span>
            </div>
        ) :
        ( <Table
            label="Registered Farmers"
            columns={farmerColumns}
            data={state.farmers}
            hidePagination={false}
        /> ) }
     </div>
    </Wrapper>
  )
}
